import type { MouseEventHandler } from "react";

import type { Gender } from "@./cat-calculations";

import type { TIconKey, TImageProps } from "@/ui/components/primitives";
import { type CatBreed } from "@/primary-models";

/*-------------------------------------
|  Types
-------------------------------------*/

export type TCatOverviewCardDefaultLabels = {
  unknown: string;
  edit: string;
};

type TUseCatOverviewCardDetailPair = {
  label: string;
  value: string;
};

type TUseCatOverviewCardDetails = {
  breed: TUseCatOverviewCardDetailPair,
  birthday: TUseCatOverviewCardDetailPair,
  neutured: TUseCatOverviewCardDetailPair
};

export type TUseCatOverviewCard = {
  eatingSince: string | null;
  details: TUseCatOverviewCardDetails;
  defaultLabels: TCatOverviewCardDefaultLabels
};

export type TCatOverview = {
  name: string;
  birthday: Date | null;
  eatingSince: Date | null;
  breed: CatBreed | null;
  gender: Gender;
  neuterStatus: boolean | null;
};

export type TCatOverviewCardProps = {
  cat: TCatOverview;
  image: TImageProps;
  editLabel?: string;
  onEdit: MouseEventHandler<HTMLButtonElement>;
};

export type TCatOverviewDetailProps = {
  icon: Extract<TIconKey, "cake" | "cat" | "mars" | "venus" | "circleSmall">;
  label: string;
  value: string;
};

/*-------------------------------------
|  Constants
-------------------------------------*/

export const CAT_GENDER_ICON_MAP: Record<Gender, Extract<TIconKey, "mars" | "venus" | "circleSmall">> = {
  BOY: "mars",
  GIRL: "venus",
  UNKNOWN: "circleSmall",
};
